import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast, Button } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';

const api = new ApiCore();


const CSOHome = (props: any) => {

    const [doctorInfo, setDoctorInfo] = useState<any>({});
    const [groupsInfo, setGroupsInfo] = useState<any>([]);

    useEffect(() => {
    }, [])

    return (
        <div className={styles.CSO_home_content}>
            <div className={styles.scan}>
                患者
            </div>
        </div>
    )
}

export default withRouter(CSOHome);